import { RootState } from "../../index";

export const getCurrentMap = (state: RootState): CurrentMap => state.currentMap;
